// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.typography-content[data-v-5ed57679] {
  position: relative;
  z-index: 10;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}
.brand-hero[data-v-5ed57679] {
  text-align: center;
  max-width: 500px;
}
.hero-title[data-v-5ed57679] {
  font-size: 72px;
  font-weight: 800;
  margin: 0 0 20px 0;
  letter-spacing: -2px;
  line-height: 1;
  text-shadow: 0 20px 40px rgba(0, 0, 0, 0.6);
  animation: slideInDown-5ed57679 0.8s ease-out;
  background: linear-gradient(135deg, #2dbdb6 0%, #45d5ce 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
@keyframes slideInDown-5ed57679 {
from {
    opacity: 0;
    transform: translateY(-30px);
}
to {
    opacity: 1;
    transform: translateY(0);
}
}
.hero-subtitle[data-v-5ed57679] {
  font-size: 32px;
  font-weight: 300;
  margin: 0 0 30px 0;
  color: #c8f0ed;
  letter-spacing: 1px;
  text-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  animation: slideInUp-5ed57679 0.8s ease-out 0.2s both;
}
@keyframes slideInUp-5ed57679 {
from {
    opacity: 0;
    transform: translateY(30px);
}
to {
    opacity: 1;
    transform: translateY(0);
}
}
.accent-bar[data-v-5ed57679] {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #2dbdb6 0%, #45d5ce 100%);
  border-radius: 2px;
  margin: 0 auto;
  animation: expandWidth-5ed57679 1s ease-out 0.4s both;
  box-shadow: 0 0 20px rgba(45, 219, 182, 0.6);
}
@keyframes expandWidth-5ed57679 {
from {
    width: 0;
    opacity: 0;
}
to {
    width: 80px;
    opacity: 1;
}
}
@media (max-width: 768px) {
.hero-title[data-v-5ed57679] {
    font-size: 44px;
}
.hero-subtitle[data-v-5ed57679] {
    font-size: 20px;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/Auth/LeftSection/BrandHero.vue"],"names":[],"mappings":";AAiBA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,2CAA2C;EAC3C,6CAAoC;EACpC,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;AAEA;AACE;IACE,UAAU;IACV,4BAA4B;AAC9B;AACA;IACE,UAAU;IACV,wBAAwB;AAC1B;AACF;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,2CAA2C;EAC3C,qDAA4C;AAC9C;AAEA;AACE;IACE,UAAU;IACV,2BAA2B;AAC7B;AACA;IACE,UAAU;IACV,wBAAwB;AAC1B;AACF;AAEA;EACE,WAAW;EACX,WAAW;EACX,4DAA4D;EAC5D,kBAAkB;EAClB,cAAc;EACd,qDAA4C;EAC5C,4CAA4C;AAC9C;AAEA;AACE;IACE,QAAQ;IACR,UAAU;AACZ;AACA;IACE,WAAW;IACX,UAAU;AACZ;AACF;AAEA;AACE;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AACF","sourcesContent":["<template>\n  <div class=\"typography-content\">\n    <div class=\"brand-hero\">\n      <h1 class=\"hero-title\">DecisionVue</h1>\n      <p class=\"hero-subtitle\">Harsh Environment</p>\n      <div class=\"accent-bar\"></div>\n    </div>\n  </div>\n</template>\n\n<script>\nexport default {\n  name: \"BrandHero\",\n};\n</script>\n\n<style scoped>\n.typography-content {\n  position: relative;\n  z-index: 10;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n}\n\n.brand-hero {\n  text-align: center;\n  max-width: 500px;\n}\n\n.hero-title {\n  font-size: 72px;\n  font-weight: 800;\n  margin: 0 0 20px 0;\n  letter-spacing: -2px;\n  line-height: 1;\n  text-shadow: 0 20px 40px rgba(0, 0, 0, 0.6);\n  animation: slideInDown 0.8s ease-out;\n  background: linear-gradient(135deg, #2dbdb6 0%, #45d5ce 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n@keyframes slideInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.hero-subtitle {\n  font-size: 32px;\n  font-weight: 300;\n  margin: 0 0 30px 0;\n  color: #c8f0ed;\n  letter-spacing: 1px;\n  text-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);\n  animation: slideInUp 0.8s ease-out 0.2s both;\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.accent-bar {\n  width: 80px;\n  height: 4px;\n  background: linear-gradient(90deg, #2dbdb6 0%, #45d5ce 100%);\n  border-radius: 2px;\n  margin: 0 auto;\n  animation: expandWidth 1s ease-out 0.4s both;\n  box-shadow: 0 0 20px rgba(45, 219, 182, 0.6);\n}\n\n@keyframes expandWidth {\n  from {\n    width: 0;\n    opacity: 0;\n  }\n  to {\n    width: 80px;\n    opacity: 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero-title {\n    font-size: 44px;\n  }\n\n  .hero-subtitle {\n    font-size: 20px;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
